import { useCallback, RefObject } from "react";

export const useFeedPagination = (ref: RefObject<HTMLElement | null>) => {
  const scrollByPage = useCallback(
    (multiplier: number) => {
      ref.current?.scrollBy({
        top: multiplier * window.innerHeight,
        behavior: "smooth",
      });
    },
    [ref]
  );

  const previous = useCallback(() => scrollByPage(-1), [scrollByPage]);
  const next = useCallback(() => scrollByPage(1), [scrollByPage]);

  return { previous, next };
};
